import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutus-container">
      <h1>About Us</h1>
      <p>We are committed to providing the best products and shopping experience to our customers. Our mission is to deliver quality, style, and service.</p>
      <p><strong>Disclaimer:</strong> Shop Scout is an independent platform and is not affiliated with, endorsed by, or in partnership with any brands featured on this website. All brand names, logos, and product images are the property of their respective owners and are used for identification purposes only.</p>
    </div>
  );
};

export default AboutUs;
